import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';

const PRIMARY = '#FA8B14';

const tabs = [
  {
    key: 'explore',
    label: 'Explore',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? PRIMARY : '#9ca3af'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill={active ? PRIMARY : 'none'} />
      </svg>
    ),
  },
  {
    key: 'community',
    label: 'Community',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? PRIMARY : '#9ca3af'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    key: 'create',
    label: '',
    isCreate: true,
  },
  {
    key: 'gallery',
    label: 'Gallery',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? PRIMARY : '#9ca3af'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <circle cx="8.5" cy="8.5" r="1.5" fill={active ? PRIMARY : '#9ca3af'} />
        <polyline points="21 15 16 10 5 21" />
      </svg>
    ),
  },
  {
    key: 'profile',
    label: 'Profile',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? PRIMARY : '#9ca3af'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export default function BottomNavBar({ activeTab, onTabChange, onCreatePress }) {
  const { colors } = useTheme();

  return (
    <nav
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        height: 64,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        background: colors.surface,
        borderTop: '1px solid rgba(255,255,255,0.08)',
        flexShrink: 0,
        position: 'relative',
        zIndex: 100,
      }}
    >
      {tabs.map((tab) => {
        if (tab.isCreate) {
          return (
            <button
              key={tab.key}
              onClick={onCreatePress}
              style={{
                width: 56,
                height: 56,
                borderRadius: 28,
                background: PRIMARY,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                marginTop: -20,
                boxShadow: '0 4px 12px rgba(250, 139, 20, 0.4)',
              }}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </button>
          );
        }

        const isActive = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 4,
              padding: '8px 0',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'transform 0.15s ease',
            }}
          >
            <div
              style={{
                width: 48,
                height: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 16,
                background: isActive ? `${PRIMARY}15` : 'transparent',
                transition: 'background 0.2s ease',
              }}
            >
              {tab.icon(isActive)}
            </div>
            <span
              style={{
                fontSize: 10,
                fontWeight: isActive ? 600 : 500,
                color: isActive ? PRIMARY : '#9ca3af',
                transition: 'color 0.2s ease',
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
